import * as React from 'react';
import { default as Empty, EmptyProps } from 'antd/lib/empty';

export const EmptyData = (props: EmptyProps) => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} {...props} />;
